import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@onward-delivery/design';
import { Edit } from '@material-ui/icons';
import { COMMODITY_OPTIONS, PROFILE_DELIVERY_TYPES } from '../profileConstants';
import { labelsFor } from '../utils';
import { formatModified, includesAny, profilePath } from './utils';

// One line of chips per cell; the profile's full details are on its own page.
const ChipList = ({ labels }) => {
    if (!labels.length) return <span className="text-muted">-</span>;
    return (
        <div className="flex flex-wrap gap-1">
            {labels.map((label) => (
                <Badge key={label} appearance="tinted" variant="success" size="xs">
                    {label}
                </Badge>
            ))}
        </div>
    );
};

// Commodity, service types and shippers are arrays, so they filter on "has any selected value" and
// don't sort.
const multiValueColumn = (id, header, options) => ({
    id,
    header,
    size: 220,
    accessorFn: (row) => row[id],
    enableSorting: false,
    filterFn: includesAny,
    meta: { filter: { type: 'multi-select', options } },
    cell: ({ getValue }) => <ChipList labels={labelsFor(options, getValue())} />,
});

export const profileColumns = ({ onEdit, shipperOptions = [] }) => [
    {
        accessorKey: 'name',
        header: 'Name',
        size: 240,
        // The way into a profile. DataTable has no row click, so the name is the link.
        cell: ({ row }) => (
            <Link
                to={profilePath(row.original.delivery_profile_id)}
                className="font-medium text-foreground underline-offset-2 hover:underline"
            >
                {row.original.name || 'Untitled profile'}
            </Link>
        ),
    },
    multiValueColumn('commodity', 'Commodity', COMMODITY_OPTIONS),
    multiValueColumn('delivery_types', 'Service types', PROFILE_DELIVERY_TYPES),
    { accessorKey: 'subregion_count', header: 'Subregions', size: 120 },
    multiValueColumn('shippers', 'Shippers', shipperOptions),
    {
        accessorKey: 'last_modified_at',
        header: 'Last modified',
        size: 150,
        cell: ({ getValue }) => formatModified(getValue()),
    },
    {
        id: 'edit',
        header: '',
        size: 60,
        enableSorting: false,
        // Locked on, and kept off the column menu.
        enableHiding: false,
        cell: ({ row }) => (
            <button
                type="button"
                aria-label={`Edit ${row.original.name}`}
                className="text-muted hover:text-foreground"
                onClick={() => onEdit(row.original.delivery_profile_id)}
            >
                <Edit fontSize="small" />
            </button>
        ),
    },
];
